import {
  openMsgModal,
  openSubModal,
  formatYYYYMMDD,
  formatHHmmss,
  displayYYYYYMMDDHHmm,
} from '@/common/Common.js'
import { SCREEN_ID, MSG_TYPE, DETAIL_SCREEN_KBN } from '@/common/const.js'
import router from '@/router'
import InformationService from './InformationService'

const screenId = SCREEN_ID.INFORMATION_LIST
const detailScreenId = SCREEN_ID.INFORMATION_DETAIL

export function init(obj) {
  // サーバーの処理後再検索
  if (obj.isReSearch == true) {
    reSearch(obj)
  }
}

export function reSearch(obj) {
  var searchCondition = obj.$store.getters['search/getSearchCondition'](
    screenId
  )
  if (searchCondition != null) {
    obj.searchCondition = JSON.parse(searchCondition)

    for (var i = 0; i < obj.searchCondition.sectionIds.length; i++) {
      addDepartment(
        obj,
        obj.searchCondition.sectionIds[i],
        '',
        obj.searchCondition.sectionNames[i]
      )
    }

    search(obj)
  }
}

export function addDepartment(obj, sectionId, sectionCode, sectionName) {
  let tableItems
  tableItems = obj.stowageTableItems

  let info = {
    // 部署ＩＤ
    section_id: sectionId,
    // 部署名
    section_name: sectionName,
  }

  let exists = false
  tableItems.forEach((item) => {
    if (item.section_id == sectionId) {
      exists = true
      return true
    }
  })

  if (exists == false) {
    tableItems.push(info)
    obj.isDisabled = false
  }
}

/**
 * 検索
 * @param {*} obj
 */
export function search(obj) {
  obj.searchCondition.sectionIds = []
  obj.searchCondition.sectionNames = []

  obj.searchCondition.displayBeginDate = formatYYYYMMDD(
    obj,
    obj.searchCondition.displayBeginDate
  )
  obj.searchCondition.displayEndDate = formatYYYYMMDD(
    obj,
    obj.searchCondition.displayEndDate
  )

  obj.searchCondition.displayBeginTime = formatHHmmss(
    obj.searchCondition.displayBeginTime
  )
  obj.searchCondition.displayEndTime = formatHHmmss(
    obj.searchCondition.displayEndTime
  )

  obj.stowageTableItems.forEach((element) => {
    obj.searchCondition.sectionIds.push(element.section_id)
    obj.searchCondition.sectionNames.push(element.section_name)
  })

  obj.$store.dispatch('init/setServiceLoading')
  InformationService.search(obj.searchCondition)
    .then(
      (response) => {
        obj.tableItems = response.data.resultList
        obj.tableItems.forEach((element) => {
          element.display_begin_date_time = displayYYYYYMMDDHHmm(
            obj,
            element.display_begin_date_time
          )
          element.display_end_date_time = displayYYYYYMMDDHHmm(
            obj,
            element.display_end_date_time
          )
        })
        if (obj.tableItems.length < 1) {
          // 警告モーダル表示
          openMsgModal(
            obj,
            MSG_TYPE.W,
            obj.$store.getters['init/getMessage']('YZ00MG907I')
          )
        }
      },
      (e) => {
        var msg
        if (e.response == undefined) {
          msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
        } else {
          msg = e.response.data.message
        }
        // エラーモーダル表示
        openMsgModal(obj, MSG_TYPE.E, msg)
      }
    )
    .finally(() => {
      obj.$store.dispatch('init/setServiceUnLoading')
    })

  var payload = {
    viewId: screenId,
    params: JSON.stringify(obj.searchCondition),
  }
  obj.$store.dispatch('search/setSearchCondition', payload)
}

/**
 * クリア
 */
export function clear(obj) {
  obj.searchCondition = obj.defaultSearchCondition()
  obj.stowageTableItems = []
  var payload = {
    viewId: screenId,
    params: JSON.stringify(obj.searchCondition),
  }
  obj.$store.dispatch('search/setSearchCondition', payload)
}

// 「詳細」ボタンクリック
export function goDetail(obj) {
  if (obj.selectedItem.length != 1) {
    openMsgModal(
      obj,
      MSG_TYPE.E,
      obj.$store.getters['init/getMessage']('YZ00MG901E')
    )
  } else {
    router.push({
      name: detailScreenId,
      params: {
        informationId: obj.selectedItem[0].information_id,
        screenKbn: DETAIL_SCREEN_KBN.DETAIL,
        beforeScreenRouteInfo: {
          routeInfo: {
            name: screenId,
            params: { isReSearch: true },
          },
        },
      },
    })
  }
}

// 「新規」ボタンクリック
export async function goNew(obj) {
  obj.$bvModal.hide('check-modal')
  router.push({
    name: detailScreenId,
    params: {
      screenKbn: DETAIL_SCREEN_KBN.NEW,
      beforeScreenRouteInfo: {
        routeInfo: {
          name: screenId,
          params: { isReSearch: true },
        },
      },
    },
  })
}

// 「コピー」ボタンクリック
export function goCopy(obj) {
  if (obj.selectedItem.length != 1) {
    openMsgModal(
      obj,
      MSG_TYPE.E,
      obj.$store.getters['init/getMessage']('YZ00MG901E')
    )
  } else {
    router.push({
      name: detailScreenId,
      params: {
        informationId: obj.selectedItem[0].information_id,
        screenKbn: DETAIL_SCREEN_KBN.COPY,
        beforeScreenRouteInfo: {
          routeInfo: {
            name: screenId,
            params: { isReSearch: true },
          },
        },
      },
    })
  }
}

// 「削除」ボタンクリック
export function goRemove(obj) {
  obj.removeMessage = obj.$store.getters['init/getMessage'](
    'YZ00MG994Q',
    obj.resultControlInfo.delete.label
  )
  openSubModal(obj, 'remove-modal')
}

/**
 * 選択した作業データを削除します.
 */
export async function remove(obj) {
  try {
    obj.$bvModal.hide('remove-modal')

    let isError = false
    let removeList = []

    obj.selectedItem.some((element) => {
      // 該当データは既に削除されています。
      if (element.deleted == '1') {
        openMsgModal(
          obj,
          MSG_TYPE.E,
          obj.$store.getters['init/getMessage']('YZ00MG904E')
        )
        isError = true
        return true
      }
    })

    if (isError) {
      return
    }

    for (let index = 0; index < obj.selectedItem.length; index++) {
      var informationId = obj.selectedItem[index].information_id
      obj.$store.dispatch('init/setServiceLoading')
      await InformationService.get(informationId)
        .then(
          (response) => {
            removeList.push(response.data)
          },
          (e) => {
            // エラーモーダル表示
            var msg
            if (e.response == undefined) {
              msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
            } else {
              msg = e.response.data.message
            }
            openMsgModal(obj, MSG_TYPE.E, msg)
            isError = true
          }
        )
        .finally(() => {
          obj.$store.dispatch('init/setServiceUnLoading')
        })
      if (isError) {
        break
      }
    }
    if (isError == false && removeList.length == obj.selectedItem.length) {
      obj.$store.dispatch('init/setServiceLoading')
      await InformationService.removeList(removeList)
        .then(
          () => {
            // 警告モーダル表示
            openMsgModal(
              obj,
              MSG_TYPE.I,
              obj.$store.getters['init/getMessage'](
                'YZ00MG995I',
                obj.resultControlInfo.delete.label
              )
            )
          },
          (e) => {
            // エラーモーダル表示
            var msg
            if (e.response == undefined) {
              msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
            } else {
              msg = e.response.data.message
            }
            openMsgModal(obj, MSG_TYPE.E, msg)
          }
        )
        .finally(() => {
          obj.$store.dispatch('init/setServiceUnLoading')
        })
    }
  } catch (err) {
    console.error(err)
  } finally {
    var searchCondition = obj.$store.getters['search/getSearchCondition'](
      screenId
    )
    obj.searchCondition = JSON.parse(searchCondition)
    search(obj)
  }
}

export function removeDepartment(obj) {
  let selectedItem
  let tableItems

  selectedItem = obj.stowageSelectedItem
  tableItems = obj.stowageTableItems

  // 一覧の選択行が存在しない場合、エラーを出力し、以降の処理は行わない。
  if (selectedItem.length == 0) {
    // 一覧より行を選択してください。
    openMsgModal(
      obj,
      MSG_TYPE.E,
      obj.$store.getters['init/getMessage']('YZ00MG901E')
    )
    return
  }

  // 選択行を一覧より、削除する。
  selectedItem.forEach((element) => {
    const index = tableItems.indexOf(element)
    tableItems.splice(index, 1)
  })
  obj.isDisabled = false
}
